import React from "react";
import {connect} from "react-redux";
import I18n from "lib/i18n/i18n";
import {dataAutomationAttr, imageUrl} from "../../helpers/ApplicationHelper";
import {MediumPrimaryButton, PhoneInput} from "@worthy-npm/clarity";
import {updateMissingDetails} from "../../actions/user";
import {bindActionCreators} from "redux";
import GA from "../../lib/ga";

const MODAL_STEPS = {
    updatePhone: 1,
    phoneUpdated: 2
}

class CompleteAccountModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            step: MODAL_STEPS.updatePhone,
            showValidationMsg: false,
            phoneInputValue: '',
            showAnimation: false
        }
    }

    onPhoneTyped = (value, isValid) => {
        this.setState({isPhoneValid: isValid, showValidationMsg: false, phoneInputValue: value.replace(/[\D\s._-]+/g, "")})
    }

    updatePhone = (stopAnimation) => {
        const {isPhoneValid} = this.state
        const {userActionsCb, version, item, ADO} = this.props

        this.setState({showValidationMsg: true})

        if (isPhoneValid) {

            this.props.updateMissingDetails({
                phone: this.state.phoneInputValue,
                user_id: ADO.user.id
            }).then(data => {
                stopAnimation();
                if (data.payload.status === 200) {
                    userActionsCb('Account information Completed', item.id, version)
                    this.setState({step: MODAL_STEPS.phoneUpdated, showAnimation: true})
                }
                else {
                    window && window.rollbar && window.rollbar.error('!!Test CompleteAccountModal - failed to update phone in db [development]')
                }
            });

        }
        else {
            stopAnimation();
            this.setState({showAnimation: false})
        }
    }

    render()
    {
        const {step, phoneInputValue, showValidationMsg, showAnimation} = this.state
        return (
            <div className={`complete-account-modal ${showAnimation ? 'modal-next-step-animation' : null}`}>
                <div className={'title'}>{I18n.getString(`completeYourAccount::modalStep${step}::title`)}</div>
                <p className={'description'}>{I18n.getString(`completeYourAccount::modalStep${step}::description`)}</p>
                {
                    step === MODAL_STEPS.updatePhone ?
                        <div className={'actions-content phone-input-wrapper'}
                             data-automation={dataAutomationAttr('missing-phone-field')}>
                            <PhoneInput
                                label={I18n.getString('listingPage::labelPhone')}
                                autoFocus={true}
                                showValidationMessage={showValidationMsg}
                                change={this.onPhoneTyped}

                            />
                            <div className='save-button'
                                 data-automation={dataAutomationAttr('save')}>
                                <MediumPrimaryButton
                                    text={I18n.getString(`completeYourAccount::modalStep${step}::buttonSave`)}
                                    disabled={phoneInputValue === ''}
                                    click={(stopAnimation) => {
                                        GA.missingInfoPopupSave()
                                        this.updatePhone(stopAnimation);
                                    }}
                                    overrideCSS={ {minWidth: '100px'} }
                                />
                            </div>
                        </div> : null
                }
                <img
                    className={`img-logos step-${step}`}
                    src={ imageUrl('trust-logos.png') }
                    key={'partners-logo'}
                    alt="Our partners"/>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({updateMissingDetails}, dispatch);
};

const mapStateToProps = ({ ADO }) => {
    return {
        ADO
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CompleteAccountModal);
